import { 
  Component,
  OnInit,
  ChangeDetectionStrategy, 
  ViewEncapsulation,
  Input} from '@angular/core';

export enum ListType {
  Default = 'default',
  Commafied = 'commafied',
  flat = 'flat'
}

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ListComponent implements OnInit {
  @Input()
  listType = ListType.Default;
  
  constructor() { }

  ngOnInit() {
   
  }
}
